import { render, staticRenderFns } from "./usuarios-consolidados.vue?vue&type=template&id=ef13543e&"
import script from "./usuarios-consolidados.vue?vue&type=script&lang=js&"
export * from "./usuarios-consolidados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports